import { Link } from 'react-router-dom';

import { PageMeta } from '@/components/PageMeta';
import { ROUTES } from '@/config/routes';
import { ArrowLeft } from 'lucide-react';

export default function NotFound() {
  return (
    <section className='pt-40 pb-20 px-6'>
      <PageMeta title='Page introuvable' robots='noindex, nofollow' />
      <div className='max-w-2xl mx-auto text-center'>
        <h1 className='text-8xl font-extrabold text-slate-200 mb-4'>404</h1>
        <h2 className='text-2xl font-bold text-slate-900 mb-4'>Page introuvable</h2>
        <p className='text-slate-500 mb-8'>La page que vous recherchez n'existe pas ou a été déplacée.</p>
        <Link
          to={ROUTES.HOME}
          className='inline-flex items-center gap-2 bg-blue-600 text-white px-8 py-3 rounded-2xl font-bold hover:bg-blue-700 transition'
        >
          <ArrowLeft className='w-5 h-5' /> Retour à l'accueil
        </Link>
      </div>
    </section>
  );
}
